import { render } from "./CalendarEventView.vue?vue&type=template&id=6501b75c"
import script from "./CalendarEventView.vue?vue&type=script&lang=js"
export * from "./CalendarEventView.vue?vue&type=script&lang=js"
script.render = render

export default script